import type { MSelect_Option } from '@shared/components/MSelect/MSelect.vue';

/**
 * Legacy single digital download product code
 */
export const SINGLE_DIGITAL_DOWNLOAD = 'SingleDigDown';
/**
 * Legacy whole digital download product code
 */
export const WHOLE_DIGITAL_DOWNLOAD = 'WholeDigDown';
export const SINGLE_DIGITAL_DOWNLOAD_RSCODE = 'Dj';
export const WHOLE_DIGITAL_DOWNLOAD_RSCODE = 'Dk';

export const DIGITAL_DOWNLOAD_CODES = [
  SINGLE_DIGITAL_DOWNLOAD,
  WHOLE_DIGITAL_DOWNLOAD,
  SINGLE_DIGITAL_DOWNLOAD_RSCODE,
  WHOLE_DIGITAL_DOWNLOAD_RSCODE,
];

export const PRODUCT_NAME_MAP: Record<string, string> = {
  [SINGLE_DIGITAL_DOWNLOAD]: 'Single Digital Download',
  [WHOLE_DIGITAL_DOWNLOAD]: 'Download All Images For Subject',
};

export interface ProductOption extends MSelect_Option {
  label: string;
  value: string;
}

export interface ProductLookupDisplayModel {
  lustreSpray: number;
  fineLinenTexture: number;
  pebbleTexture: number;
  mount: number;
  none: number;
  metallic: number;
  eSurface: number;
  product: string;
  rsProduct: string;
  id: number;
  cost: number;
  addWeight: number;
  shipTier: string;
  dieCut: number;
  weight: string;
  isSportsEnabled: boolean;
  isSchoolsEnabled: boolean;
}

export interface ProductLookupCreateModel {
  rsProduct: string;
  product: string;
  eSurface: number;
  metallic: number;
  none: number;
  pebbleTexture: number;
  fineLinenTexture: number;
  lustreSpray: number;
  dieCut: number;
  weight: string;
  shipTier: string;
  cost: number;
  mount: number;
  addWeight: number;
  isSportsEnabled: boolean;
  isSchoolsEnabled: boolean;
}

export interface ProductLookupUpdateModel {
  rsProduct: string;
  product: string;
  eSurface: number;
  metallic: number;
  none: number;
  pebbleTexture: number;
  fineLinenTexture: number;
  lustreSpray: number;
  dieCut: number;
  weight: string;
  shipTier: string;
  cost: number;
  mount: number;
  addWeight: number;
  isSportsEnabled: boolean;
  isSchoolsEnabled: boolean;
}

export interface PackageItemDTO {
  productCode: string;
  quantity: number;
  itemGroup: string;
}
